import { Text } from "react-native";
import { EMBER } from "../../onboarding/theme";

export default function SupplementOrderingNote() {
  return (
    <Text
      className="font-dm-sans"
      style={{
        fontSize: 12,
        color: EMBER.colors.textFaint,
        textAlign: "center",
        marginTop: 8,
      }}
    >
      Coming soon: In-app ordering
    </Text>
  );
}
